import React from 'react';
import { Grid, Segment, Button, Header, Icon, Container } from 'semantic-ui-react';
import HeaderSubHeader from 'semantic-ui-react/dist/commonjs/elements/Header/HeaderSubheader';

const PuntosPagoInfo = () => {

    return <Grid>
        <Grid.Column width={16}>
            <Segment clearing>
                <Container text>
                    <br />
                    <Header as='h2' textAlign="center">
                        <Icon name="calendar check outline" />
                        No tengo dificultad, puedo pagar mis cuotas.
                    </Header>
                    {/* <Header size="small" textAlign="center">
                        <HeaderSubHeader>
                            Te recomendamos evitar salir de casa, y acudir a las agencias solo cuando sea necesario.
                        </HeaderSubHeader>

                    </Header> */}
                    <Header size="small" textAlign="center">
                        <HeaderSubHeader>
                            Puede efectuar el pago de su crédito en las ventanillas de nuestra Red de Agencias sin ningún costo.
                            <br />
                            <br />
                            Asimismo, para el pago de la cuota de su crédito, tiene habilitado los Servicios de Recaudación de los siguientes
                            Bancos y Compañías:

                        </HeaderSubHeader>
                    </Header>

                    <Header size="small" textAlign="left">
                        <HeaderSubHeader>
                            <ul>
                                <li>
                                    <strong>BANCO DE CRÉDITO (Sin Costo)</strong>
                                    <br />
                                    <br />
                                    Red de Agencias y Agentes BCP, indicando su número de crédito y el Código de Recaudación Nº 00354
                                </li>
                                <br />
                                <li>
                                    <strong>BANCO CONTINENTAL</strong>
                                    <br />
                                    <br />
                                    - Banco Continental, pago por Ventanilla (Costo S/. 3.00) (*)
                                    <br />
                                    <br />
                                    - Agentes Express BBVA Banco Continental (Costo S/. 2.00) (*)
                                    <br />
                                    <br />
                                    - BBVA Banco Continental pago en Banca por Internet (Sin Costo) (*)
                                    <br />
                                    <br />
                                    - Agentes Kasnet(Costo S/. 2.00) (**)
                                    <br />
                                    <br />
                                    <strong>(*) Presentando su DNI e indicando el Código de Recaudación Nº 8125</strong>
                                    <br />
                                    <br />
                                    <strong>(**) Presentando su DNI e indicando el Código de Recaudación Nº 008125</strong>
                                </li>
                                <br />
                            </ul>
                        </HeaderSubHeader>

                    </Header>
                    <br />
                    <br />
                    <Grid textAlign='center'>
                        <Button
                            size='hunge'
                            content='Ubícanos'
                            icon="world"
                            primary
                            onClick={() => {
                                window.location.href = 'https://prymera.pe/contacto';
                                return null;
                            }}
                        />
                    </Grid>
                    <br />
                    <br />
                </Container>

            </Segment>
        </Grid.Column>
    </Grid>;
}

export default PuntosPagoInfo
